import request from './request';
import { isUat } from './detector';
function getLogin(redirect, useQuickLogin) {
    if (redirect === void 0) { redirect = true; }
    if (useQuickLogin === void 0) { useQuickLogin = false; }
    var req = request({
        method: 'get',
        url: "//" + (isUat ? 'uat-' : '') + "api.bilibili.com/x/web-interface/nav",
        query: {
            jsonp: 'jsonp',
        },
    });
    return req
        .then(function (res) { return (+res.code === 0 ? res : Promise.reject(res)); })
        .catch(function (reason) {
        if (+reason.code === -101) {
            var ua = window.navigator.userAgent;
            var isBiliApp = ua.toLowerCase().indexOf('biliapp') >= 0;
            if (isBiliApp) {
                if (!redirect) {
                    return Promise.reject(reason);
                }
                window.location.href = "https://" + (isUat ? 'uat-' : '') + "passport.bilibili.com/login?gourl=" + window.location.href;
            }
            else {
                if (!redirect) {
                    return Promise.reject(reason);
                }
                if (useQuickLogin) {
                    openQuickLogin();
                }
                else {
                    window.location.href = "https://" + (isUat ? 'uat-' : '') + "passport.bilibili.com/login?gourl=" + window.location.href;
                }
            }
        }
        return Promise.resolve();
    });
}
export function openQuickLogin() {
    var script = document.createElement('script');
    script.src = "//" + (isUat ? 'uat-' : '') + "s1.hdslb.com/bfs/seed/jinkela/short/mini-login/miniLogin.umd.min.js";
    script.onload = function () {
        var miniLogin = new window.MiniLogin();
        miniLogin.showComponent();
        miniLogin.addEventListener('success', function () {
            window.location.reload();
        });
    };
    document.body.appendChild(script);
}
export default getLogin;
//# sourceMappingURL=getLogin.js.map